module.exports = __webpack_public_path__ + "files/4513bf6ac5b7aa7de8c316862b77ed90.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-bold-webfont.woff2
// module id = 669
// module chunks = 60